// File: OrderItemsList.js

import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useSmartBack } from '../../shared/navigation';
import { useQuery } from '@tanstack/react-query';

import { getOrderByOrderId } from '../services/api/implementation/impl'; // <-- Your new API call
import Layout from '../components/layout/AppLayout';
import Header from '../../shared/components/layout/Header';
import OrderActivityCard from './OrderActivityCard'; // <-- Similar to your DealCard but for orders
import { useSidebar } from '../../shared/contexts/SidebarContext';
import mixpanel from 'mixpanel-browser';
import Cookies from 'js-cookie';
import Loader from '../../shared/components/ui/Loader';
import Table from '../../shared/components/layout/Table';
import GridWrapper from '../../shared/components/layout/GridWrapper';

// Icons
const TaxIcon = () => (
  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M9 7h6m0 10v-3m-3 3h.01M9 17h.01M9 14h.01M12 14h.01M15 11h.01M12 11h.01M9 11h.01M7 21h10a2 2 0 002-2V5a2 2 0 00-2-2H7a2 2 0 00-2 2v14a2 2 0 002 2z"
    />
  </svg>
);

const CalendarIcon = () => (
  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
    />
  </svg>
);

const StatusIcon = () => (
  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
    />
  </svg>
);

const ClockIcon = () => (
  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
    />
  </svg>
);

const MoneyIcon = () => (
  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1"
    />
  </svg>
);

const DiscountIcon = () => (
  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z"
    />
  </svg>
);

const TruckIcon = () => (
  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M9 17a2 2 0 11-4 0 2 2 0 014 0zM19 17a2 2 0 11-4 0 2 2 0 014 0z"
    />
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M13 16V6a1 1 0 00-1-1H4a1 1 0 00-1 1v10a1 1 0 001 1h1m8-1a1 1 0 01-1 1H9m4-1V8a1 1 0 011-1h2.586a1 1 0 01.707.293l3.414 3.414a1 1 0 01.293.707V16a1 1 0 01-1 1h-1m-6-1a1 1 0 001 1h1M5 17a2 2 0 104 0m-4 0a2 2 0 114 0m6 0a2 2 0 104 0m-4 0a2 2 0 114 0"
    />
  </svg>
);

const ExtraIcon = () => (
  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 100 4m0-4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 100 4m0-4v2m0-6V4"
    />
  </svg>
);

const PaymentIcon = () => (
  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z"
    />
  </svg>
);

const OrderItemsList = () => {
  const userId = Cookies.get('userId');
  const { collapsed } = useSidebar();
  const { id } = useParams();
  const { onBack } = useSmartBack({ fallback: '/builder/inventory/orders' });

  // Fetch order activities by order ID
  const {
    data: orderActivities,
    refetch: refetchOrderActivities,
    isLoading
  } = useQuery({
    queryKey: ['orderActivities', id],
    queryFn: () => getOrderByOrderId(id),
    enabled: !!id // Ensures the query runs only when `id` is available
  });

  console.log('orderActivities:', orderActivities);

  // Track page view
  useEffect(() => {
    mixpanel.track('Order Activity List Viewed', {
      user_id: userId,
      timestamp: new Date().toISOString()
    });
  }, [userId]);

  return (
    <Layout>
      <Loader isVisible={isLoading} />
      {/* Header */}
      <div
        className={`fixed z-[10] top-0 transition-all duration-300 ease-in-out ${
          collapsed ? 'left-[76px] right-0' : 'left-64 right-0'
        }`}>
        <Header data={{ name: 'Order Items' }} backArrow={true} onBack={onBack} />
      </div>

      <div className={`transition-all duration-300 ease-in-out ${collapsed ? 'ml-[1vw]' : ''}`}>
        <GridWrapper width={100}>
          {/* Quotation Details Section */}
          {orderActivities?.quotation && (
            <div className="mt-[5rem] mb-4 bg-gradient-to-br from-white to-gray-50 rounded-xl shadow-lg border border-gray-100 p-3">
              <div className="flex items-center gap-3 mb-1">
                <div className="p-2 bg-blue-100 rounded-lg">
                  <svg
                    className="w-4 h-4 text-blue-600"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24">
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                    />
                  </svg>
                </div>
                <h2 className="text-xl font-bold text-gray-800">Quotation Details</h2>
              </div>

              {/* Basic Information */}
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
                <div className="flex items-center justify-between p-1.5 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors">
                  <div className="flex items-center gap-2">
                    <div className="p-0.5 bg-purple-100 rounded-md">
                      <TaxIcon />
                    </div>
                    <span className="text-sm font-medium text-gray-700">Tax Type</span>
                  </div>
                  <span className="text-sm font-semibold text-gray-800">
                    {orderActivities.quotation.taxType || 'N/A'}
                  </span>
                </div>

                <div className="flex items-center justify-between p-3 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors">
                  <div className="flex items-center gap-3">
                    <div className="p-1 bg-indigo-100 rounded-md">
                      <ClockIcon />
                    </div>
                    <span className="text-sm font-medium text-gray-700">Created</span>
                  </div>
                  <span className="text-sm font-semibold text-gray-800">
                    {orderActivities.quotation.created_at
                      ? new Date(orderActivities.quotation.created_at).toLocaleDateString('en-IN')
                      : 'N/A'}
                  </span>
                </div>

                <div className="flex items-center justify-between p-3 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors">
                  <div className="flex items-center gap-3">
                    <div className="p-1.5 bg-green-100 rounded-md">
                      <MoneyIcon />
                    </div>
                    <span className="text-sm font-medium text-gray-700">Total Amount</span>
                  </div>
                  <span className="text-sm font-bold text-green-600">
                    ₹
                    {new Intl.NumberFormat('en-IN').format(
                      orderActivities.quotation.total_amount || 0
                    )}
                  </span>
                </div>

                <div className="flex items-center justify-between p-3 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors">
                  <div className="flex items-center gap-3">
                    <div className="p-1.5 bg-orange-100 rounded-md">
                      <DiscountIcon />
                    </div>
                    <span className="text-sm font-medium text-gray-700">Discount</span>
                  </div>
                  <span className="text-sm font-semibold text-orange-600">
                    {orderActivities.quotation.discount || 0}%
                  </span>
                </div>

                <div className="flex items-center justify-between p-3 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors">
                  <div className="flex items-center gap-3">
                    <div className="p-1.5 bg-blue-100 rounded-md">
                      <TruckIcon />
                    </div>
                    <span className="text-sm font-medium text-gray-700">Shipping Charges</span>
                  </div>
                  <span className="text-sm font-semibold text-blue-600">
                    ₹
                    {new Intl.NumberFormat('en-IN').format(
                      orderActivities.quotation.shippingCharges || 0
                    )}
                  </span>
                </div>

                <div className="flex items-center justify-between p-3 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors">
                  <div className="flex items-center gap-3">
                    <div className="p-1.5 bg-red-100 rounded-md">
                      <ExtraIcon />
                    </div>
                    <span className="text-sm font-medium text-gray-700">Extra Charges</span>
                  </div>
                  <span className="text-sm font-semibold text-red-600">
                    ₹
                    {new Intl.NumberFormat('en-IN').format(
                      orderActivities.quotation.extraCharges || 0
                    )}
                  </span>
                </div>
              </div>

              {/* Payment Terms */}
              {orderActivities.quotation.paymentTerms &&
                orderActivities.quotation.paymentTerms.length > 0 && (
                  <div className="mt-4 p-2 bg-gradient-to-r from-blue-50 to-indigo-50 rounded-xl border border-blue-100">
                    <div className="flex items-center gap-3 mb-2">
                      <div className="p-2 bg-blue-100 rounded-lg">
                        <PaymentIcon />
                      </div>
                      <h3 className="text-lg font-semibold text-gray-800">Payment Terms</h3>
                    </div>
                    <div className="grid gap-2">
                      {orderActivities.quotation.paymentTerms.map((term, index) => (
                        <div
                          key={index}
                          className="flex items-start gap-3 p-3 bg-white rounded-lg shadow-sm border border-blue-50">
                          <div className="w-2 h-2 bg-blue-500 rounded-full mt-2 flex-shrink-0"></div>
                          <span className="text-sm text-gray-700 leading-relaxed">{term}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
            </div>
          )}

          <div className="relative table-container">
            <style>{`
            .table-container .table-body {
              position: static !important;
              overflow-y: visible !important;
              max-height: none !important;
              height: auto !important;
              top: auto !important;
              padding-bottom: 0 !important;
            }
            .table-container .table-container {
              height: auto !important;
            }
            .table-container > div {
              height: auto !important;
            }
          `}</style>
            <Table
              headers={['Item Name', 'Category', 'Unit', 'Quantity', 'Total Amount']}
              data={
                orderActivities?.poItems?.map((poItem, index) => ({
                  'Item Name': poItem.item?.item_name,
                  Category: poItem.item?.category_name,
                  Unit: poItem.item?.unit,
                  Quantity: poItem.quantity,
                  'Total Amount':
                    poItem.totalAmount != null
                      ? `₹${new Intl.NumberFormat('en-IN').format(poItem.totalAmount)}`
                      : ''
                })) || []
              }
              isWrap={true}
            />
          </div>
        </GridWrapper>
      </div>
    </Layout>
  );
};

export default OrderItemsList;
